// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"32fed503","66":"bac3ad7c","107":"b852f4cf","142":"bb383a3c","159":"28610f6b","285":"8a19bc15","871":"a7d603c1"}[chunkId] + ".chunk.js";
};